import React from 'react';
import { heroImage } from '../mock';
import { ArrowRight } from 'lucide-react';

const Hero = () => {
  return (
    <section id="top" className="relative min-h-[90vh] lg:min-h-[760px] w-full overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src={heroImage}
          alt="Dach płaski"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/45 to-black/5" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/15 via-transparent to-black/30" />
      </div>

      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10 pt-[160px] pb-[100px] lg:pt-[180px] lg:pb-[120px]">
        <div className="max-w-[640px]">
          <div className="border-l-2 border-[#e30613] pl-6">
            <h1 className="text-white font-black uppercase leading-[1.1] tracking-tight text-[26px] md:text-[32px] lg:text-[36px]">
              Dachy płaskie, które mają być szczelne przez lata — nie tylko wyglądać dobrze po odbiorze.
            </h1>
            <p className="mt-7 text-white/75 text-[14px] md:text-[15px] leading-relaxed max-w-xl">
              Specjalistyczne wykonanie dachów płaskich, tarasów
              i hydroizolacji w systemach EPDM, RESITRIX, TPO i PVC.
              Pracujemy dla inwestorów, którzy chcą mieć dach
              zrobiony raz, dokładnie i bez kompromisów na detalach.
            </p>
            <div className="mt-9 flex flex-wrap items-center gap-4">
              <a
                href="#kontakt"
                className="group inline-flex items-center gap-2 bg-[#e30613] hover:bg-[#c40510] text-white text-[12px] tracking-[0.2em] font-semibold px-7 py-4 transition-colors duration-200"
              >
                UMÓW OGLĘDZINY DACHU
                <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform duration-200" />
              </a>
              <a
                href="#realizacje"
                className="inline-flex items-center gap-2 border border-white/40 hover:border-white text-white text-[12px] tracking-[0.2em] font-semibold px-7 py-4 transition-colors duration-200"
              >
                ZOBACZ REALIZACJE
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
